<div class="wrapper">
  <div class="container-fluid">
    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item active">Merchant and Terminal Configuration</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <!-- end page title -->

    <div class="row">
      <div class="col-12">
        <div class="card-box">

          <div class="row">
           <div class="form-group" *ngIf="raiseDanger" style="width:100%;">
              <div class="col-md-12 form-horizontal px-6" style="width:100%;">
                <ngb-alert type="danger" [dismissible]="false" style="width:100%;">
                  <strong>Error!</strong> {{danger}}
                </ngb-alert>
              </div>
            </div>
          </div>

          <ul ngbNav #nav="ngbNav" class="nav nav-tabs">
            <li [ngbNavItem]="1">
              <a ngbNavLink>Merchant and Terminal Configuration</a>
              <ng-template ngbNavContent>
                <form [formGroup]="TerminalConfigFormGroup">
                  <div class="form-group row">
                    <label for="terminalConfig" class="col-3 col-form-label">Select Participant</label>
                    <div class="col-9">
                      <ng-select2 id="participantId" formControlName="participantId" [data]="participantIdSelect2" [options]="select2options" [placeholder]="'Please select a participant...'" (valueChanged)="participantChange($event)"></ng-select2>
                    </div>
                  </div>

                  <div class="row form-horizontal">

                    <div class="col-md-6 form-horizontal px-3">

                      <div>
                        <br />
                        <b style="color: #477c93;"> Terminal details</b>
                        <div class="fc-divider dropdown-divider" style="border: 1px solid #2db0e5 "></div>
                        <br />
                      </div>

                      <div class="form-group row" *ngIf="participantSelected">
                        <label for="terminalConfig" class="col-3 col-form-label">Terminal Config</label>
                        <div class="col-9">
                          <ng-select2 id="terminalConfig" formControlName="terminalConfig" [data]="terminalConfigsSelect2" [options]="select2options" [placeholder]="'Please select a terminal config...'"></ng-select2>
                        </div>
                      </div>

                      <div class="form-group row">
                        <label for="terminalType" class="col-3 col-form-label">Terminal Type</label>
                        <div class="col-9">
                          <ng-select2 id="terminalType" formControlName="terminalType" [data]="termTypes" [options]="select2options"></ng-select2>
                          <ul *ngIf="submitted" class="parsley-errors-list filled">
                            <li *ngIf="TerminalConfigFormGroup.controls['terminalType'].hasError('required')" class="parsley-required">Terminal type is required.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row">
                        <label for="productProfile" class="col-3 col-form-label">Product Profile</label>
                        <div class="col-9">
                          <ng-select2 id="productProfile" formControlName="productProfile" [data]="productProfiles" [options]="select2options"></ng-select2>
                          <ul *ngIf="submitted" class="parsley-errors-list filled">
                            <li *ngIf="TerminalConfigFormGroup.controls['productProfile'].hasError('required')" class="parsley-required">Product profile is required.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row">
                        <label for="terminalCapabilities" class="col-3 col-form-label">Terminal Capabilities</label>
                        <div class="col-9">
                          <ng-select2 id="terminalCapabilities" formControlName="terminalCapabilities" [data]="capabilityProfiles" [options]="select2options"></ng-select2>
                          <ul *ngIf="submitted" class="parsley-errors-list filled">
                            <li *ngIf="TerminalConfigFormGroup.controls['terminalCapabilities'].hasError('required')" class="parsley-required">Terminal capability profile is required.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row">
                        <label for="commsProfile" class="col-3 col-form-label">Comms Profile</label>
                        <div class="col-9">
                          <ng-select2 id="commsProfile" formControlName="commsProfile" [data]="commsProfiles" [options]="select2options"></ng-select2>
                          <ul *ngIf="submitted" class="parsley-errors-list filled">
                            <li *ngIf="TerminalConfigFormGroup.controls['commsProfile'].hasError('required')" class="parsley-required">Comms profile is required.</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 form-horizontal px-3">
                      <div>
                        <br />
                        <b style="color: #477c93;"> Merchant details</b>
                        <div class="fc-divider dropdown-divider" style="border: 1px solid #2db0e5"></div>
                        <br />
                      </div>

                      <div class="form-group row">
                        <label for="cardSet" class="col-4 col-form-label">Card Set</label>
                        <div class="col-8">
                          <ng-select2 id="cardSetFC" formControlName="cardSetFC" [data]="cardSets" [options]="select2options"></ng-select2>
                          <ul *ngIf="submitted || this.TerminalConfigFormGroup.controls['cardSetFC'].touched" class="parsley-errors-list filled">
                            <li *ngIf="this.TerminalConfigFormGroup.controls['cardSetFC'].hasError('required')" class="parsley-required">Card set is required.</li>
                          </ul>
                        </div>
                      </div>

                      <div class="form-group row">
                        <label for="countryCode" class="col-4 col-form-label">Country</label>
                        <div class="col-8">
                          <ng-select2 id="countryFC" formControlName="countryFC" [data]="countries" [options]="select2options"></ng-select2>
                          <ul *ngIf="submitted || this.TerminalConfigFormGroup.controls['countryFC'].touched" class="parsley-errors-list filled">
                            <li *ngIf="this.TerminalConfigFormGroup.controls['countryFC'].hasError('required')" class="parsley-required">Country is required.</li>
                          </ul>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="form-group mb-0 justify-content-end row">
                    <div class="col-9">
                      <button type="submit" class="btn btn-info waves-effect waves-light float-right" (click)="addConfig()">
                        Add Config
                      </button>
                    </div>
                  </div>
                </form>
                <br>
                <div class="row">
                  <div class="col-12">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th>Participant</th>
                          <th>Terminal Config</th>
                          <th>Terminal Type</th>
                          <th>Product Profile</th>
                          <th>Terminal Capabilities</th>
                          <th>Comms Profile</th>
                          <th>Card Set</th>
                          <th>Country</th>
                          <th>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr scope="col" *ngFor="let s of merchantTerminalConfigs">
                          <td>{{s.participantId}}</td>
                          <td>{{s.terminalConfig}}</td>
                          <td>{{s.terminalType}}</td>
                          <td>{{s.productProfile}}</td>
                          <td>{{s.terminalCapabilities}}</td>
                          <td>{{s.commsProfile}}</td>
                          <td>{{s.cardSet}}</td>
                          <td>{{s.country}}</td>
                          <td>
                            <button type="button"
                                    class="btn btn-danger waves-effect waves-light  fa-pull-right"
                                    (click)="removeService(s.id)">
                              Delete <i class="mdi mdi-delete"></i>
                            </button>
                            &nbsp;
                            <button type="button"
                                    class="btn btn-info waves-effect waves-light fa-pull-right"
                                    (click)="editService(s.id)">
                              Edit <i class="mdi mdi-pencil"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ng-template>
            </li>

          </ul>
          <div [ngbNavOutlet]="nav" class="tab-pane"></div>
        </div>
      </div>
    </div>
  </div>
</div>
